export enum TypeAlternative {
  common = 'common',
  custom = 'custom'
}
